import { UseQueryResult } from 'react-query'
import { useGetAccounts, useGetProfile } from '@yuno/dashboard-api-mfe'
import { Organization, User } from '@yuno/types'
import { useEffect, useState } from 'react'
//import { useLogout } from '../../account-menu/hooks'

export const useAccounts = (organizationCodeStaff) => {
  //const { isNotAuth } = useLogout()

  const {
    data,
    isLoading,
    refetch,
    error,
    isSuccess,
  }: UseQueryResult<Organization.Account[], unknown> = useGetAccounts(
    organizationCodeStaff,
  )

  useEffect(() => {
    //isNotAuth(data)
  }, [data])

  return {
    refetch,
    isLoadingAccount: isLoading,
    accounts: !data?.code ? data : null,
    error,
    organizationCodeStaff,
    success: isSuccess,
  }
}

export const useProfile = () => {
  const [customer, setCustomer] = useState()

  const { data, isLoading }: UseQueryResult<User.UserResponsePayload, unknown> =
    useGetProfile()

  useEffect(() => {
    !!data && setCustomer(data.code)
  }, [data])

  return {
    isLoadingProfile: isLoading,
    profile: data,
    customer,
  }
}
